/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router-dom";
import PageRoot from "../../../components/common/form/PageRoot";
import SubVacanciesList from "../../../components/corporate/recruitment/SubVacanciesList";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useEffect, useState } from "react";
import RecruitmentHeader from "../../../components/common/layout/RecruitmentHeader";
import { useTranslation } from "react-i18next";
import { sitemap } from "../../../shared/utils/sitemap";
import { useSelector } from "react-redux";
import Canonical from "../../../components/common/layout/Canonical";

const SubVacancies = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const { t } = useTranslation('common');
    const params = useParams();
    const navigate = useNavigate();

    const getAdDetail = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url?.publicAd}${params?.id}/`);

            if (res && res.status === 200) {
                setData(res?.data)
                setLoading(false)
                sitemap()
            }
        } catch (error: any) {
            setIsError(true)
            setLoading(false)
            if (error?.response?.status === 404) {
                (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
            }
            console.error("error while fetching ad detail", error);
        }
    }

    useEffect(() => {
        (!!params?.id && !!lang) && getAdDetail();
    }, [params?.id, lang])

    return (
        <>
            <Canonical />
            <div className="w-full h-full dark:bg-bgDarkDull bg-white">
                <div className="relative z-[1]">
                    <RecruitmentHeader />
                    <PageRoot page={t("recruitment.home.all_vacancies")} subPage={data?.adv_no} />
                </div>

                <div id="home">
                    <SubVacanciesList data={data} loading={loading} isError={isError} />
                </div>
            </div>
        </>
    );
};

export default SubVacancies;